<template>
  <div style="width: 100%; height: 100%; padding-left: 252px">
    <v-card elevation="0">
      <v-card-title class="pl-10">
        基本信息<v-spacer />
        <v-btn-toggle dense>
          <v-btn @click="del(appsd.apps.id)" class="red--text" outlined><v-icon size="18" class="mr-1" color="red">mdi-delete-outline</v-icon> 删除</v-btn>
        </v-btn-toggle>
      </v-card-title>
      <v-row>
        <v-col md="4">
          <div class="pl-6">
            <v-list-item two-line>
              <v-list-item-avatar size="80" color="blue-grey lighten-5" style="border-radius: 18px">
                <v-icon color="primary" size="36">{{ appsd.apps.props || "mdi-microsoft-windows" }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="pt-0">
                <v-list-item-title class="title mb-5">{{ appsd.apps.name || "加载中..." }}</v-list-item-title>
                <v-list-item-subtitle class="body-1 red--text">
                  <v-chip class="mr-2 rounded" color="cyan" small outlined> {{ appsd.apps.leve | dict("0:国家级应用/2:省级应用/4:市级应用/6:区县级应用") }} </v-chip>
                  <v-chip class="mr-2 rounded" :color="appsd.apps.type | dict('1:blue/2:orange/3:green')" small outlined> {{ appsd.apps.type | dict("1:治理端/2:服务端/3:协同端") }} </v-chip>
                  <v-chip class="mr-2 rounded" :color="appsd.apps.auth | dict('0:green/1:orange')" small outlined> {{ appsd.apps.auth | dict("0:开放应用/1:授权应用") }} </v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-col>
        <v-col md="6">
          <v-list-item two-line>
            <v-list-item-content class="pt-10">
              <v-list-item-subtitle class="mb-5"
                >应用标识：
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <span @click="copy(appsd.apps.id)" :class="hover ? 'copy_hover' : ''" class="vtk-cursor-pointer">{{ appsd.apps.id }}</span>
                  </template>
                </v-hover>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                应用状态：
                <span :class="appsd.apps.state | dict('0:red--text/1:green--text')">{{ appsd.apps.state | dict("0:未上线/1:已上线") }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card>

    <!-- 应用信息 -->
    <v-card class="mt-6" style="height: calc(100% - 204px)" elevation="0">
      <v-card-title class="pl-10 py-2">
        应用信息<v-spacer />
        <v-btn v-if="isShow" class="mr-3" color="success" elevation="0" @click="save"> <v-icon size="18" class="mr-1">mdi-checkbox-marked-circle-outline</v-icon> 保存 </v-btn>
        <v-btn v-if="isShow" elevation="0" @click="close"><v-icon size="18" class="mr-1">mdi-close</v-icon> 取消</v-btn>
        <v-btn v-else @click="edit" color="primary" elevation="0"><v-icon size="18" class="mr-1">mdi-puzzle-edit-outline</v-icon> 编辑</v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-10">
        <v-form v-if="isShow" ref="entity" v-model="valid">
          <v-row style="max-width: 900px">
            <v-col md="12" class="pb-0">
              应用名称：
              <v-text-field v-model="entity.name" :rules="[(v) => !!v || '应用名称不能为空！']" persistent-hint class="mt-1" placeholder="请输入应用名称" outlined dense> </v-text-field>
            </v-col>
            <v-col md="12" class="py-0">
              应用授权：
              <wtk-select v-model="entity.auth" class="mt-1" placeholder="请选择应用授权" :rules="[(v) => !!v || '应用授权不能为空!']" list="0:开放应用/1:授权应用" dense outlined></wtk-select>
            </v-col>
            <v-col md="12" class="py-0">
              移动端地址：
              <v-text-field
                v-model="entity.muri"
                hint="请输入http或https开头的链接，如 https://www.zj.gov.cn，如为空请填写#"
                :rules="[(v) => /(http|https):\/\/([\w.]+\/?)\S*/.test(v) || v == '#' || '请填写正确的网址，以http://或https://开头!']"
                persistent-hint
                class="mt-1"
                placeholder="请输入移动端地址"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-col md="12" class="pb-0">
              桌面端地址：<v-text-field
                v-model="entity.puri"
                :rules="[(v) => /(http|https):\/\/([\w.]+\/?)\S*/.test(v) || v == '#' || '请填写正确的网址，以http://或https://开头!']"
                hint="请输入http或https开头的链接，如 https://www.zj.gov.cn，如为空请填写#"
                persistent-hint
                class="mt-1"
                placeholder="请输入桌面端地址"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col md="12" class="pb-0">
              大屏端地址：<v-text-field
                v-model="entity.turi"
                :rules="[(v) => /(http|https):\/\/([\w.]+\/?)\S*/.test(v) || v == '#' || '请填写正确的网址，以http://或https://开头!']"
                hint="请输入http或https开头的链接，如 https://www.zj.gov.cn，如为空请填写#"
                persistent-hint
                class="mt-1"
                placeholder="请输入大屏端地址"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col md="12" class="pb-0"> 应用介绍：<v-textarea v-model="entity.note" :rules="[(v) => !!v || '应用介绍不能为空  !']" class="mt-2" dense placeholder="请输入应用介绍" rows="3" outlined></v-textarea> </v-col>
          </v-row>
        </v-form>
        <v-row v-else class="pb-6" style="">
          <v-col md="12">移动端地址：{{ appsd.apps.muri }} </v-col>
          <v-col md="12">桌面端地址：{{ appsd.apps.puri }} </v-col>
          <v-col md="12">大屏端地址：{{ appsd.apps.turi }} </v-col>
          <v-col md="12">{{ appsd.apps.note }} </v-col>
        </v-row>
        <v-divider />
        <v-row class="py-6">
          <v-col md="12">开发单位：{{ appsd.acid.entName }} ( {{ appsd.acid.entCode }} )</v-col>
          <v-col md="12"
            >开发标识：
            <v-hover>
              <template v-slot:default="{ hover }">
                <span @click="copy('开发标识：' + appsd.acid.corpId)" :class="hover ? 'copy_hover' : ''" class="vtk-cursor-pointer">{{ appsd.acid.corpId }}</span>
              </template>
            </v-hover>
          </v-col>
          <v-col md="12"
            >开发秘钥：
            <v-hover>
              <template v-slot:default="{ hover }">
                <span @click="copy('开发秘钥：' + appsd.acid.corpSecret)" :class="hover ? 'copy_hover' : ''" class="vtk-cursor-pointer">{{ appsd.acid.corpSecret }}</span>
              </template>
            </v-hover>
          </v-col>
          <v-col md="12">地址限制：{{ appsd.acid.ip }} </v-col>
          <v-col md="12">地区限制：{{ appsd.acid.areaName }} ( {{ appsd.acid.areaCode }} ) </v-col>
        </v-row>
        <v-divider />
        <v-card-title class="pt-3 font-weight-regular body-1 px-0 pb-0">
          关联目录
          <v-spacer />
          <v-btn v-if="isShow" @click="editProj" color="primary" elevation="0" text small>修改</v-btn>
        </v-card-title>
        <v-row class="pt-4">
          <v-col v-for="(item, index) in appsd.abiz" :key="index" md="3" sm="3">
            <v-list-item class="rounded" style="border: 1px #eee solid">
              <v-list-item-avatar>
                <v-img :src="item.projIcon"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.projName }}</v-list-item-title>
                <v-list-item-subtitle>编码：{{ item.projCode }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <vtk-proj ref="Mproj" @toPage="projSave" />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Message from "@/components/message";
import Request from "@/commons/request";
import wtkSelect from "@/components/dictionary/WtkSelect";
export default {
  components: { wtkSelect },
  props: {
    appsd: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    entity: "",
    valid: true,
    isShow: false,
  }),
  mounted() {
    this.isShow = false;
  },
  methods: {
    //编辑应用信息
    edit() {
      this.isShow = true;
      this.entity = Object.assign({}, this.appsd.apps);
    },
    // 关闭应用编辑
    close() {
      this.$refs.entity.reset();
      this.isShow = false;
    },
    //删除应用
    del(id) {
      if (this.appsd.apps.state == "0") {
        Message.confirm({ title: "提示", color: "red--text", text: "您确定要删除该应用吗，删除后将无法恢复，请谨慎操作！！！" }, (result) => {
          if (result) {
            Request.postForm("/app/apps/delete", { id: id }).then((res) => {
              if (res.meta.success) {
                Message.toast("删除成功", { color: "success" });
                this.$router.push("/uams/apps");
              } else {
                Message.toast("删除失败，请联系管理员", { color: "error" });
              }
            });
          }
        });
      } else {
        Message.toast("当前应用处于上线状态，请联系管理员下线应用后再删除", { color: "error" });
      }
    },
    //服务选择
    editProj() {
      this.$refs.Mproj.add(this.appsd.apps);
    },
    projSave(bizCode) {
      let data = {
        id: this.$route.query.aid,
        bizCode: bizCode,
      };
      this.submit(data);
    },
    save() {
      if (this.$refs.entity.validate()) {
        Message.loading.show();
        let subData = {};
        subData.id = this.$route.query.aid;
        subData.name = this.entity.name;
        subData.auth = this.entity.auth;
        subData.note = this.entity.note;
        subData.muri = this.entity.muri;
        subData.puri = this.entity.puri;
        subData.turi = this.entity.turi;
        this.submit(subData);
      }
    },
    submit(data) {
      Request.postJson("/app/apps/save", data).then((res) => {
        Message.loading.hide();
        if (res.meta.success) {
          this.isShow = false;
          this.appsd.apps = this.entity;
          this.$emit("refresh", this.$route.query.aid);
          Message.toast("修改成功！", { color: "success" });
        } else {
          Message.toast(res.meta.message, { color: "error" });
        }
      });
    },
    //拷贝文本
    copy(txt) {
      navigator.clipboard.writeText(txt).then(() => {
        Message.toast("复制成功", { color: "success" });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.copy_hover {
  background: rgba(162, 201, 255, 0.297);
  &::after {
    content: " 复制";
    color: rgb(0, 102, 255);
  }
}
</style>